export { useParentBlock } from "@webiny/app-page-builder-elements/renderers/block/BlockProvider";
